var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.29262 3.23012C3.40246 3.12029 3.40246 2.94221 3.29262 2.83238C3.18279 2.72254 3.00471 2.72254 2.89488 2.83238L0.926126 4.80113C0.816291 4.91096 0.816291 5.08904 0.926126 5.19887L2.89488 7.16762C3.00471 7.27746 3.18279 7.27746 3.29262 7.16762C3.40246 7.05779 3.40246 6.87971 3.29262 6.76988L1.52275 5L3.29262 3.23012Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70738 3.23012C5.59754 3.12029 5.59754 2.94221 5.70738 2.83238C5.81721 2.72254 5.99529 2.72254 6.10512 2.83238L8.07387 4.80113C8.18371 4.91096 8.18371 5.08904 8.07387 5.19887L6.10512 7.16762C5.99529 7.27746 5.81721 7.27746 5.70738 7.16762C5.59754 7.05779 5.59754 6.87971 5.70738 6.76988L7.47725 5L5.70738 3.23012Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.f8854be61bef213adab29f0e57392ede.svg";
export { ForwardRef as ReactComponent };